import React from 'react';
import PropTypes from 'prop-types';
import WorkOrderCard from 'workOrderComponents/WorkOrderCard';
import AddressFromBillerButton from 'workOrderComponents/AddressFromBillerButton';
import RefreshHeader from 'layoutComponents/RefreshHeader';
import Toggle from 'material-ui/Toggle';
import {isFinalStateByDispatchStatus} from 'utils/orderStatusUtils';
import {FormattedPlural} from 'react-intl';
import TextFormatter from 'utils/TextFormatter';

class AssignedServiceOrders extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.handleReloadWorkOrders = this.handleReloadWorkOrders.bind(this);
        this.handleShowCloseOrderToggle = this.handleShowCloseOrderToggle.bind(this);   
    }

    handleReloadWorkOrders() {

        const {workOrderActions, userId, isSelf} = this.props;

        workOrderActions.workOrderGetTechRouteStarted({userId: userId, isSelf: isSelf});
    }

    handleShowCloseOrderToggle(e) {
        e.preventDefault();
        const {workOrderActions, workOrder} = this.props;
        workOrderActions.setShowClosedOrders(!workOrder.get('showClosedOrders'));
    }

    render() {
        const {
            assignedServiceOrders,
            workOrderActions,
            routeRefreshed,
            history,
            workOrderLoading,
            workOrder
        } = this.props;
        let message = null;

        if (!assignedServiceOrders) {
            return null;
        }

        if (!assignedServiceOrders || assignedServiceOrders.count() === 0) {
            message = (
                <h6>No Orders to Display</h6>
            );
        }

        if (workOrderLoading) {
            message = (
                <div className="wow-fst-loading-message">Loading Route...</div>
            );
        }

        const workOrderDetails = workOrder.get('workOrderDetails');

        const sections = [];

        let closedOrderCount = 0;
        let openOrdersCount = 0;

        if (assignedServiceOrders && assignedServiceOrders.count() > 0) {

            assignedServiceOrders.forEach((item, assignedServiceOrdersIndex) => {
                if (item && item.get('orderIds')) {

                    const rows = [];

                    item
                        .get('orderIds')
                        .forEach((orderId, orderIdIndex) => {
                            let billingSystemAddressDisplay = null;
                            const billingSystemAddress = workOrderDetails.getIn([orderId, 'billerAddress', 'details']);
                            let billingSystemAddressButton = null;
                            const dispatchStatus = workOrderDetails.getIn([orderId, 'schedulingSystemDetails', 'details', 'serviceOrderInfoV2', 'dispatchStatus']);

                            if(orderId.toLowerCase().startsWith('u'))
                            {    
                                billingSystemAddressButton = (
                                    <div>                                        
                                    <br/>
                                    <AddressFromBillerButton workOrderActions={workOrderActions} workOrderDetails={workOrderDetails.get(orderId)} orderId={orderId}/>
                                    </div>                              
                                );

                                if(billingSystemAddress && billingSystemAddress.streetAddress && billingSystemAddress.city && billingSystemAddress.zip){
                                    billingSystemAddressDisplay = (
                                        <div>
                                            <h6>From Biller:</h6>
                                            <a href={TextFormatter.generateMapLink(billingSystemAddress.streetAddress, billingSystemAddress.city, billingSystemAddress.zip)} target='_blank' rel="noopener noreferrer">
                                                 {TextFormatter.titleCase('', billingSystemAddress.streetAddress)} {billingSystemAddress.apartmentNo}
                                                 <br/> {TextFormatter.titleCase('', billingSystemAddress.city)}, {billingSystemAddress.state} {billingSystemAddress.zip}
                                            </a> 
                                        </div>
                                       
                                    );
                                }
                            }

                            const newItem = (
                                <div
                                    key={String(orderId)}
                                    style={{
                                    border: 'solid 1px #e0e0e0',
                                    marginBottom: '25px'
                                }}><WorkOrderCard
                                    showViewButton
                                    workOrderActions={workOrderActions}
                                    workOrder={workOrderDetails.get(orderId)}
                                    history={history}/>
                                    {billingSystemAddressButton}
                                    {billingSystemAddressDisplay}
                                </div>
                            );

                            if (!isFinalStateByDispatchStatus(dispatchStatus)) {

                                rows.push(newItem);

                            }

                            if (isFinalStateByDispatchStatus(dispatchStatus) && workOrder.get('showClosedOrders')) {
                                rows.push(newItem);

                            }

                            if (isFinalStateByDispatchStatus(dispatchStatus)) {
                                closedOrderCount += 1;
                            } else {
                                openOrdersCount += 1;
                            }

                        });
                    sections.push(
                        <div key={`assignedServiceOrders_section_${assignedServiceOrdersIndex}`}>
                            <h6 className="center-align">Tech: {item.get('techId')}</h6>
                            {rows}
                        </div>
                    );

                }

            });
        }

        const showOrdersLabel = (
            <span>Show {workOrder.get('showClosedOrders')}
                {closedOrderCount}&nbsp;Closed&nbsp;
                <FormattedPlural value={closedOrderCount} one="Order" other="Orders"/>?</span>
        );

        let toggle = (<Toggle
            toggled={workOrder.get('showClosedOrders')}
            onToggle={this.handleShowCloseOrderToggle}
            label={showOrdersLabel}
            labelPosition="right"/>);

        if (closedOrderCount === 0) {
            toggle = null;
        }

        if (openOrdersCount === 0 && !workOrderLoading) {
            message = (
                <h6 className="wow-fst-no-data-message">No Open Orders to Display</h6>
            );
        }

        return (
            <div >

                <RefreshHeader
                    header="Route"
                    loadedTime={routeRefreshed}
                    onTouchTap={this.handleReloadWorkOrders}/> {toggle}
                {message}
                {sections}
            </div>
        );
    }

}

AssignedServiceOrders.propTypes = {
    assignedServiceOrders: PropTypes.object,
    workOrderActions: PropTypes.object,
    routeRefreshed: PropTypes.object,
    userId: PropTypes.string,
    workOrderLoading: PropTypes.bool,
    history: PropTypes.object,
    isSelf: PropTypes.bool,
    workOrder: PropTypes.object
};

export default AssignedServiceOrders;


// WEBPACK FOOTER //
// ./src/components/work-order/AssignedServiceOrders.js